import { jwtVerify, errors } from 'jose'

const pubKey = `-----BEGIN PUBLIC KEY-----
MCowBQYDK2VwAyEAR+0xzlb5SsllZPzF1AKxyxBcUVqHKWwVPJgSLXLJVV0=
-----END PUBLIC KEY-----`

function pemToArrayBuffer(pem: string): ArrayBuffer {
    // Удаляем заголовки PEM и переносы строк
    const b64 = pem
        .replace('-----BEGIN PUBLIC KEY-----', '')
        .replace('-----END PUBLIC KEY-----', '')
        .replace(/\s/g, '');

    // Декодируем base64 в строку
    const binary = atob(b64);

    // Конвертируем в ArrayBuffer
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return bytes.buffer;
}

export interface Limits {
    limit_life_part: number
    limit_trackers: number
    limit_lists: number
    limit_tasks: number
    limit_checklists: number
    limit_tracker_api: boolean
    limit_my_wheels: number
    limit_client_wheels: number
}



export interface Payload {
    email: string
    plan: string
    planId: number
    limits: Limits
    iat: number
    exp: number
    planExp: number
}

export interface VerifyResult {
    status: "OK" | "EXPIRED" | "FAILED" | "ERROR"
    payload?: Payload
}

export async function verifyLicense(token: string): Promise<VerifyResult> {
    const key = await crypto.subtle.importKey(
        "spki",
        pemToArrayBuffer(pubKey),
        { name: "Ed25519" },
        false,
        ["verify"]
    )

    try {
        const { payload } = await jwtVerify<Payload>(token, key);
        return {
            status: "OK",
            payload
        }
    }
    catch (error) {
        if (error instanceof errors.JWTExpired) {
            return { status: "EXPIRED" }
        }
        if (error instanceof errors.JWSSignatureVerificationFailed) {
            return { status: "FAILED" }
        }
    }
    return { status: "ERROR" }
}

export function getDaysRemaining(timestamp: number): number {
    const now = Math.floor(Date.now() / 1000)
    const diff = timestamp - now
    return Math.max(0, Math.ceil(diff / (60 * 60 * 24)))
}

export function getPlanExpirationDate(timestamp: number): Date {
    return new Date(timestamp * 1000)
}